import LoginPage from './LoginPage.jsx';

export default function LoginShellPage(props) {
    return <LoginPage {...props} fullPageNavigation />;
}
